import { render, staticRenderFns } from "./DefaultContainerLMU.vue?vue&type=template&id=1627a771&"
import script from "./DefaultContainerLMU.vue?vue&type=script&lang=js&"
export * from "./DefaultContainerLMU.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports